import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Subject } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';

import { AppComponent } from 'src/app/app.component';
import { ToasterService } from '../framework/toaster/toaster.service';
import { ArrayUtil } from '../framework/utils/array-util';
import { ErrorHandlerService } from '../framework/error-handler.service';


@Component({
  selector: 'app-anexo-bottom-panel',
  templateUrl: './anexo-bottom-panel.component.html',
  styleUrls: ['./anexo-bottom-panel.component.css']
})
export class AnexoBottomPanelComponent implements OnInit, OnDestroy {

  @ViewChild('fileUpload') fileUpload: FileUpload;

  private subjectFiles: Subject<File[]>;

  private subjectOnClickCancelar: Subject<void>;

  private subjectAfterUpload: Subject<any>;

  private subjectOnError: Subject<any>;

  public titulo = '';
  public valorQrcode: string;
  public fileLimit = null;
  public maxFileSizeMb: number = null;
  public accept = 'image/*'; /* image/*, text/html */
  public url: string;
  public autoUpload = false;
  public nomeDoArquivo = 'arquivo';

  public labelSolteArquivoCustomizado = '';

  exibirDropZone = true;

  arquivos: File[] = [];
  quantidadeArquivos = 0;

  constructor(
    private toasterService: ToasterService
    , private appComponent: AppComponent
    , private errorHandlerService: ErrorHandlerService
  ) {
    this.subjectFiles = new Subject();
    this.subjectOnClickCancelar = new Subject();
    this.subjectAfterUpload = new Subject();
    this.subjectOnError = new Subject();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if ( this.subjectFiles ) {
      this.subjectFiles.complete();
    }

    if ( this.subjectAfterUpload ) {
      this.subjectAfterUpload.complete();
    }

    if ( this.subjectOnClickCancelar ) {
      this.subjectOnClickCancelar.complete();
    }

    if ( this.subjectOnError ) {
      this.subjectOnError.complete();
    }
  }


  getSubjectFiles(): Subject<File[]> {
    return this.subjectFiles;
  }

  getSubjectOnClickCancelar(): Subject<void> {
    return this.subjectOnClickCancelar;
  }

  getSubjectAfterUpload(): Subject<any> {
    return this.subjectAfterUpload;
  }

  getSubjectOnError(): Subject<any> {
    return this.subjectOnError;
  }

  cancelar(): void {
    this.subjectOnClickCancelar.next();
    this.appComponent.getBottomPanel().esconder();
  }

  upload(): void {
    this.subjectFiles.next(this.arquivos);
  }

  getFileUploadComonent(): FileUpload {
    return this.fileUpload;
  }

  onSelect(event: any): void {
    this.quantidadeArquivos = event.currentFiles.length;

    if ( this.quantidadeArquivos > 0 ) {
      this.exibirDropZone = false;
    }

    if ( event.currentFiles && event.currentFiles.length > 0 ) {
      this.arquivos.push(event.currentFiles[0]);
    }
  }

  onRemove(event: any): void {
    this.quantidadeArquivos--;

    if ( this.quantidadeArquivos === 0 ) {
      this.exibirDropZone = true;
    }

    ArrayUtil.removerObjetoDoArray(this.arquivos, event.file);
  }

  onError(event: any): void {
    this.subjectOnError.next(event?.error);

    if ( event?.error ) {
      this.errorHandlerService.handle(event.error);
    }
    else {
      this.toasterService.error('Operação não realizada');
    }
  }

  onBeforeSend(event: any): void {
    console.log('on-before-send', event);
  }

  onBeforeUpload(event: any): void {
    console.log('on-before-upload', event);
  }

  onUpload(event: any): void {
    this.subjectAfterUpload.next(event);
  }

}
